import classNames from 'classnames';
import Icon, { IconProps } from '../../Atoms/Icon';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';

export interface Props {
  title: string;
  text: string;
  icon: IconProps;
  color?: 'blue' | 'white';
  className?: string;
}

function CardBenefits({
  title,
  text,
  icon,
  color = 'blue',
  className
}: Props) {
  return (
    <div
      className={classNames([
        'mx-auto flex max-w-md flex-col gap-5 lg:flex-row',
        className
      ])}
    >
      <div className="flex w-full items-center justify-center lg:w-24 lg:items-start">
        <Icon
          icon={icon}
          className={classNames([
            'h-[30px] w-[30px] text-sl-indigo',
            color === 'white' && 'text-white'
          ])}
        />
      </div>
      <div className="flex w-full flex-col gap-3 text-center lg:max-w-[calc(100%-100px)] lg:text-left">
        <Title
          as="h2"
          size={4}
          color={color}
          className="leading-none md:leading-none lg:leading-none"
        >
          {title}
        </Title>
        <Text color={color} className="text-opacity-50">
          {text}
        </Text>
      </div>
    </div>
  );
}

export default CardBenefits;
